import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialInstitution: ITrialInstitutionLoadActionCreator = () => {
        return {
            type: ACTION_TRIALINSTITUTION_LOAD
        }
    },
    LoadTrialInstitutionsByTrialId: ITrialInstitutionsLoadByTrialIdActionCreator = (trialId) => {
        return {
            type: ACTION_TRIALINSTITUTIONS_LOAD_BY_TRIAL_ID,
            trialId
        }
    },
    LoadTrialInstitutionsByInstitutionId: ITrialInstitutionsLoadByInstitutionIdActionCreator = (institutionId) => {
        return {
            type: ACTION_TRIALINSTITUTIONS_LOAD_BY_INSTITUTION_ID,
            institutionId
        }
    },
    LoadTrialInstitutionById: ITrialInstitutionLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALINSTITUTION_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialInstitutionLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTION_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialInstitutionLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTION_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialInstitution: ITrialInstitutionSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTION_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialInstitutionSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTION_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialInstitutionSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTION_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrialInstitution: ITrialInstitutionCreateActionCreator = (trialId) => {

        return {
            type: ACTION_TRIALINSTITUTION_CREATE,
            trialId
        }
    },
    CreateSuccess: ITrialInstitutionCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALINSTITUTION_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialInstitutionCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTION_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialInstitution: ITrialInstitutionValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTION_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialInstitutionValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTION_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialInstitutionValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTION_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialInstitutionClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALINSTITUTION_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialInstitutionFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALINSTITUTION_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALINSTITUTION_LOAD = "ACTION_TRIALINSTITUTION_LOAD",
    ACTION_TRIALINSTITUTIONS_LOAD_BY_TRIAL_ID = "ACTION_TRIALINSTITUTIONS_LOAD_BY_TRIAL_ID",
    ACTION_TRIALINSTITUTIONS_LOAD_BY_INSTITUTION_ID = "ACTION_TRIALINSTITUTIONS_LOAD_BY_INSTITUTION_ID",
    ACTION_TRIALINSTITUTION_LOAD_BY_ID = "ACTION_TRIALINSTITUTION_LOAD_BY_ID",
    ACTION_TRIALINSTITUTION_LOAD_SUCCESS = "ACTION_TRIALINSTITUTION_LOAD_SUCCESS",
    ACTION_TRIALINSTITUTION_LOAD_FAILURE = "ACTION_TRIALINSTITUTION_LOAD_FAILURE",

    ACTION_TRIALINSTITUTION_SAVE = "ACTION_TRIALINSTITUTION_SAVE",
    ACTION_TRIALINSTITUTION_SAVE_SUCCESS = "ACTION_TRIALINSTITUTION_SAVE_SUCCESS",
    ACTION_TRIALINSTITUTION_SAVE_FAILURE = "ACTION_TRIALINSTITUTION_SAVE_FAILURE",

    ACTION_TRIALINSTITUTION_CREATE = "ACTION_TRIALINSTITUTION_CREATE",
    ACTION_TRIALINSTITUTION_CREATE_SUCCESS = "ACTION_TRIALINSTITUTION_CREATE_SUCCESS",
    ACTION_TRIALINSTITUTION_CREATE_FAILURE = "ACTION_TRIALINSTITUTION_CREATE_FAILURE",

    ACTION_TRIALINSTITUTION_VALIDATE = "ACTION_TRIALINSTITUTION_VALIDATE",
    ACTION_TRIALINSTITUTION_VALIDATE_SUCCESS = "ACTION_TRIALINSTITUTION_VALIDATE_SUCCESS",
    ACTION_TRIALINSTITUTION_VALIDATE_FAILURE = "ACTION_TRIALINSTITUTION_VALIDATE_FAILURE",

    ACTION_TRIALINSTITUTION_CLEAR = "ACTION_TRIALINSTITUTION_CLEAR",

    ACTION_TRIALINSTITUTION_FILTER = "ACTION_TRIALINSTITUTION_FILTER";

export interface ITrialInstitutionLoadAction {
    type: "ACTION_TRIALINSTITUTION_LOAD";
}

export interface ITrialInstitutionLoadActionCreator {
    (): ITrialInstitutionLoadAction;
}

export interface ITrialInstitutionLoadSuccessAction {
    type: "ACTION_TRIALINSTITUTION_LOAD_SUCCESS";
    formData: Dtos.TrialInstitution | Dtos.TrialInstitution[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLoadSuccessActionCreator {
    (
        formData: Dtos.TrialInstitution | Dtos.TrialInstitution[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLoadSuccessAction;
}

export interface ITrialInstitutionLoadFailureAction {
    type: "ACTION_TRIALINSTITUTION_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLoadFailureAction;
}

export interface ITrialInstitutionsLoadByTrialIdAction {
    type: "ACTION_TRIALINSTITUTIONS_LOAD_BY_TRIAL_ID";
    trialId: number;
}

export interface ITrialInstitutionsLoadByTrialIdActionCreator {
    (trialId: number): ITrialInstitutionsLoadByTrialIdAction;
}

export interface ITrialInstitutionsLoadByInstitutionIdAction {
    type: "ACTION_TRIALINSTITUTIONS_LOAD_BY_INSTITUTION_ID";
    institutionId: number;
}

export interface ITrialInstitutionsLoadByInstitutionIdActionCreator {
    (institutionId: number): ITrialInstitutionsLoadByInstitutionIdAction;
}

export interface ITrialInstitutionLoadByIdAction {
    type: "ACTION_TRIALINSTITUTION_LOAD_BY_ID";
    id: number;
}

export interface ITrialInstitutionLoadByIdActionCreator {
    (id: number): ITrialInstitutionLoadByIdAction;
}


export interface ITrialInstitutionSaveAction {
    type: "ACTION_TRIALINSTITUTION_SAVE";
    formData: Dtos.TrialInstitution;

}

export interface ITrialInstitutionSaveActionCreator {
    (
        formData: Dtos.TrialInstitution
    ): ITrialInstitutionSaveAction;
}

export interface ITrialInstitutionSaveSuccessAction {
    type: "ACTION_TRIALINSTITUTION_SAVE_SUCCESS";
    formData: Dtos.TrialInstitution;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionSaveSuccessActionCreator {
    (
        formData: Dtos.TrialInstitution,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionSaveSuccessAction;
}

export interface ITrialInstitutionSaveFailureAction {
    type: "ACTION_TRIALINSTITUTION_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionSaveFailureAction;
}

export interface ITrialInstitutionCreateAction {
    type: "ACTION_TRIALINSTITUTION_CREATE",
    trialId: number
}

export interface ITrialInstitutionCreateActionCreator {
    (trialId: number): ITrialInstitutionCreateAction
}

export interface ITrialInstitutionCreateSuccessAction {
    type: "ACTION_TRIALINSTITUTION_CREATE_SUCCESS";
    formData: Dtos.TrialInstitution;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialInstitutionCreateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitution,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialInstitutionCreateSuccessAction;
}

export interface ITrialInstitutionCreateFailureAction {
    type: "ACTION_TRIALINSTITUTION_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionCreateFailureAction;
}

export interface ITrialInstitutionValidateAction {
    type: "ACTION_TRIALINSTITUTION_VALIDATE";
    formData: Dtos.TrialInstitution;

}

export interface ITrialInstitutionValidateActionCreator {
    (
        formData: Dtos.TrialInstitution
    ): ITrialInstitutionValidateAction;
}

export interface ITrialInstitutionValidateSuccessAction {
    type: "ACTION_TRIALINSTITUTION_VALIDATE_SUCCESS";
    formData: Dtos.TrialInstitution;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionValidateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitution,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionValidateSuccessAction;
}

export interface ITrialInstitutionValidateFailureAction {
    type: "ACTION_TRIALINSTITUTION_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionValidateFailureAction;
}

export interface ITrialInstitutionClearAction {
    type: "ACTION_TRIALINSTITUTION_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialInstitutionClearActionCreator {
    (propertiesToClear?: string[]): ITrialInstitutionClearAction;
}

export interface ITrialInstitutionFilterActionCreator {
    (formFilter: IFormFilter): ITrialInstitutionFilterAction;
}

export interface ITrialInstitutionFilterAction {
    type: "ACTION_TRIALINSTITUTION_FILTER";
    formFilter: IFormFilter;
}

export type TrialInstitutionAction =
    ITrialInstitutionLoadAction |
    ITrialInstitutionsLoadByTrialIdAction |
    ITrialInstitutionsLoadByInstitutionIdAction |
    ITrialInstitutionLoadByIdAction |
    ITrialInstitutionLoadFailureAction |
    ITrialInstitutionLoadSuccessAction |
    ITrialInstitutionSaveAction |
    ITrialInstitutionSaveSuccessAction |
    ITrialInstitutionSaveFailureAction |
    ITrialInstitutionCreateAction |
    ITrialInstitutionCreateSuccessAction |
    ITrialInstitutionCreateFailureAction |
    ITrialInstitutionValidateAction |
    ITrialInstitutionValidateSuccessAction |
    ITrialInstitutionValidateFailureAction |
    ITrialInstitutionClearAction | 
    ITrialInstitutionFilterAction;
